import createIcon from '../../createIcon';

/**
 * @component @name DoNotDisturbOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxMC41VjEyLjVIMTYuMDRMMjAuNzIgMTcuMThDMjEuODQgMTUuNTcgMjIuNSAxMy42MSAyMi41IDExLjVDMjIuNSA1Ljk4IDE4LjAyIDEuNSAxMi41IDEuNUMxMC4zOSAxLjUgOC40MyAyLjE2IDYuODIgMy4yOEwxNC4wNCAxMC41SDE3LjVaTTIuNzcgMS43N0wxLjUgMy4wNEw0LjI4IDUuODJDMy4xNiA3LjQzIDIuNSA5LjM5IDIuNSAxMS41QzIuNSAxNy4wMiA2Ljk4IDIxLjUgMTIuNSAyMS41QzE0LjYxIDIxLjUgMTYuNTcgMjAuODQgMTguMTggMTkuNzJMMjAuOTYgMjIuNUwyMi4yMyAyMS4yM0wyLjc3IDEuNzdaTTcuNSAxMi41VjEwLjVIOC45NkwxMC45NiAxMi41SDcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoNotDisturbOff = createIcon('DoNotDisturbOff', [
  [
    'path',
    {
      d: 'M17.5 10.5V12.5H16.04L20.72 17.18C21.84 15.57 22.5 13.61 22.5 11.5C22.5 5.98 18.02 1.5 12.5 1.5C10.39 1.5 8.43 2.16 6.82 3.28L14.04 10.5H17.5ZM2.77 1.77L1.5 3.04L4.28 5.82C3.16 7.43 2.5 9.39 2.5 11.5C2.5 17.02 6.98 21.5 12.5 21.5C14.61 21.5 16.57 20.84 18.18 19.72L20.96 22.5L22.23 21.23L2.77 1.77ZM7.5 12.5V10.5H8.96L10.96 12.5H7.5Z',
      key: '4pp5bw',
    },
  ],
]);

export default DoNotDisturbOff;
